import React, { useState } from "react";
import "components/Layout/style.css";
import DateImgIcon from "assets/img/dateimg.svg";
import { Grid, TextField } from "@mui/material";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import DatePicker from "react-datepicker";
import {  Store } from "../../../../components/Ui";

function range(start, end, step) {
  const len = Math.floor((end - start) / step) + 1;
  return Array(len).fill().map((_, idx) => start + (idx * step));
}

const years = range(1990, new Date().getFullYear() + 1, 1);
const months = [
  "Janvier",
  "Fevrier",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];
const DateStep = (props) => {
  const [dateStock, setDateStock] = useState(new Date());
  const {
    state: {
      activeFarm,
      activeCampaign,
    }
  } = React.useContext(Store);
  const handleSubmit = () => {
    // if (isValid)
    if (dateStock) {
      let campaignId=activeCampaign && activeCampaign.id ? activeCampaign.id : null;
      props.onSubmit({ dateStock, "campaignId":campaignId, farmId: activeFarm.id });
    } else {
      setErrors(`veuillez choisir une date`);
    }
  };

  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          containImg={DateImgIcon}
          content={"Fiche de Stock"}
          title={"Date"}
          buttonLabel={"Continuer"}
          task={"Veillze à définir la date à laquelle le stock a été mise à jour."}
          handleSubmit={handleSubmit}
        >
          <div className="mt-14 text-center mb-14">
            <DatePicker style={{ border: "none" }}
              inline
              renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
              }) => (
                <div
                  style={{
                    margin: 10,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button style={{ fontSize: "15pt" }} onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    {"<"}
                  </button>
                  <select style={{ border: "1px solid #ddd", margin: "0 10px", padding: "7px", borderRadius: "3px" }}
                    value={date.getFullYear()}
                    onChange={({ target: { value } }) => changeYear(value)}
                  >
                    {years.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <select style={{ border: "1px solid #ddd", margin: "0 10px", padding: "7px", borderRadius: "3px" }}
                    value={months[date.getMonth()]}
                    onChange={({ target: { value } }) =>
                      changeMonth(months.indexOf(value))
                    }
                  >
                    {months.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>

                  <button style={{ fontSize: "15pt" }} onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    {">"}
                  </button>
                </div>
              )}
              selected={dateStock}
              onChange={(date) => setDateStock(date)}
            />
          </div>

        </WelcomeLayout>
      </Grid>
    </div >
  );
};

export default DateStep;
